// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"980":"055c10d0","3396":"8e1e355b","3459":"8317b628","4013":"adf16bdb","5101":"96e3841e","5782":"b6d70103"}[chunkId] + ".chunk.css";
};